import * as controls from './controls';
import * as pages from './pages';
import type { MetadataInstanceInterface } from '../../common/decoration/factory';
import { MetadataFactory } from '../../common/decoration/factory';
import { v2, PageTypeV2, SAPUI5_FRAGMENT_CLASS, SAPUI5_VIEW_CLASS } from '@sap/ux-specification-types';

/**
 * Note: If the key of the elements corresponds to the name of the definition in schema, you do not have to list it explicitly here.
 * The following tables only comprise entries for elements that do not follow the official pattern (yet)
 */
const alpElements = {
    //no deviations
};

const lrElements = {
    Table: controls.ResponsiveTable,
    ResponsiveTableWithMultiSelect: controls.ResponsiveTable,
    ResponsiveTableWithInlineDelete: controls.ResponsiveTable
};

const ovpElements = {
    [v2.CardSettingsType.listCardSettings]: controls.ListCard,
    [v2.CardSettingsType.listCardSettingsv4]: controls.ListCard,
    [v2.CardSettingsType.analyticalCardSettings]: controls.AnalyticalCard,
    [v2.CardSettingsType.analyticalCardSettingsv4]: controls.AnalyticalCard,
    [v2.CardSettingsType.stackCardSettings]: controls.StackCard,
    [v2.CardSettingsType.linkListCardSettings]: controls.LinklistCard,
    [v2.CardSettingsType.tableCardSettings]: controls.TableCard,
    [v2.CardSettingsType.tableCardSettingsv4]: controls.TableCard
};

const opElements = {
    [SAPUI5_VIEW_CLASS]: controls.ObjectPageCustomSectionView,
    [SAPUI5_FRAGMENT_CLASS]: controls.ObjectPageCustomSectionFragment,
    Table: controls.ObjectPageResponsiveTable, //default
    ObjectPageResponsiveTableWithMultiSelect: controls.ObjectPageResponsiveTable,
    ObjectPageResponsiveTableWithInlineDelete: controls.ObjectPageResponsiveTable
};

export const pageTypes = {
    [PageTypeV2.AnalyticalListPage]: alpElements,
    [PageTypeV2.ListReport]: lrElements,
    [PageTypeV2.ObjectPage]: opElements,
    [PageTypeV2.OverviewPage]: ovpElements
};

/**
 * V2 specific factory class for creating instances of (reflect) metadata classes
 */
export class MetadataInstanceFactoryV2 extends MetadataFactory implements MetadataInstanceInterface {
    constructor() {
        super(controls, pages, pageTypes);
    }
}
